"use client";
import { SessionProvider } from "@sajilni/auth/react";
import Toaster from "@/lib/sonner";
import { DirectionProvider, TooltipProvider } from "ui";
import { LocaleProvider, useLocale, type Locales } from "@sajilni/localization";
import { BrandingInitializer } from "@/components/branding/BrandingInitializer";
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import type { AnalyticsEnvironment } from "@/lib/analytics/catalog";

function RadixDirection({ children }: { children: React.ReactNode }) {
  const locale = useLocale();
  return (
    <DirectionProvider dir={locale === "ar" ? "rtl" : "ltr"}>
      {children}
    </DirectionProvider>
  );
}

export function Providers({
  children,
  locale,
  analyticsEnvironment,
}: {
  children: React.ReactNode;
  locale: Locales;
  analyticsEnvironment: AnalyticsEnvironment;
}) {
  return (
    <SessionProvider>
      <LocaleProvider value={locale}>
        <AnalyticsProvider environment={analyticsEnvironment}>
          <RadixDirection>
            <TooltipProvider>
              <Toaster />
              <BrandingInitializer />
              {children}
            </TooltipProvider>
          </RadixDirection>
        </AnalyticsProvider>
      </LocaleProvider>
    </SessionProvider>
  );
}
